<div class="error-panel">
  <h1 class="error-title">{{ 'common.error.title' | translate }}</h1>
  <mat-card class="error-message">
    <p>{{ 'common.error.default-message' | translate }}</p>
  </mat-card>
    <button mat-flat-button class="logout btn-common" (click)="reloadRequested.emit()">
      {{ 'common.error.reload-btn' | translate }}
    </button>
</div>